<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Reports" title="Customers Report" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
		
							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-10 d-flex">
										<span style="font-size: 20px; font-weight: bolder;">Customers Report</span>
									</div>
								</div>
							</div>
		
							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-4" style="margin-top: 27px;">
										<label class="d-flex listing-length">
											<span>Show</span>
											<select class="form-select"  v-model="listing_length" @change="fetchReport()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
											
									<div class="col-md-3">
										<label class="control-label">Start Date:<span class="text-danger">*</span></label>
										<input class="form-control" type="date" v-model="start_date" :min="min" :max="max" value-as-string @input="fetchReport()">
									</div>
									<div class="col-md-3">
										<label class="control-label">End Date:<span class="text-danger">*</span></label>
										<input class="form-control" type="date" v-model="end_date" :min="min" :max="max" value-as-string  @input="fetchReport()">
									</div>
									<div class="col-md-2" style="margin-top: 27px;">
										<div v-if="Boolean(users.length)" class="btn btn-info"  @click="generatePDF()">Pdf</div>
									</div>
								</div>
							</div>
		
							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
									<tr>
											<th class="sorting_asc" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-sort="ascending" aria-label="Image: activate to sort column descending"
												style="width: 415.266px;">Image</th>
											<th class="sorting_asc" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-sort="ascending" aria-label="Name: activate to sort column descending"
												style="width: 275.266px;">Name</th>
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Email & Mobile: activate to sort column ascending"
												style="width: 337.797px;">Email & Mobile</th>
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Location: activate to sort column ascending"
												style="width: 337.797px;">Location</th>
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Reg. on: activate to sort column ascending"
												style="width: 215.797px;">Reg. on</th>
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Options: activate to sort column ascending"
												style="width: 515.266px;">Options</th>	
									</tr>
									</thead>
									<tbody v-if="Boolean(users.length)">
										<tr v-for="user in users" :key="user.id">
											<td><img v-if="user.image" :src="$image_url + user.image" alt="Image not found" style="width:80px" /></td>
											<td>{{ user.name }}</td>
											<td>{{ user.email }}<br />{{ user.phone_number }}</td>
											<td>{{user.location}}</td>
											<td>
												{{$filters.formatDateTime(user.created_at)}}
											</td>
											<td><router-link :to="{name: 'users.show', params: { id: user.id }}" class="btn btn-sm btn-primary mt-2 mr-1" >View</router-link></td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="6" class="text-center">No data</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchReport(page.url + '&start_date=' + start_date + '&end_date=' + end_date +  '&limit=' + listing_length)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
		
						</div>
					</div>
				</div>
			</div>
		</div>
 
 
	  
   </div>
 </template>



<script>
	export default {
		name: "CustomerReport",
		
		data() {

			const now = new Date()
	      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
	      const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
	      const minDate = new Date('2021-01-01') 
	      
			return {
				users: [],
				pagination: {},
				start_date: '2021-01-01',
				end_date: today_str,
				
				min: minDate,
				max: today,
				keyword: "",
				listing_length: 10,
				token: "",				
			};
		},
		mounted() {},

		created() {
			this.fetchReport();			
		},

		methods: {

			
			fetchReport(page_url = null) {
				let url = "/api/admin/reports/customers?start_date=" + this.start_date + "&end_date=" + this.end_date + "&limit=" + this.listing_length;
				page_url = page_url || url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.users = responseData.data;
						this.pagination = responseData.links;
					})
					.catch((err) => console.log(err));
			},

			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },

			generatePDF() {
				this.getToken();
				let page_url = "/api/admin/reports/customers_pdf?start_date=" + this.start_date + "&end_date=" + this.end_date;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
					.then((response) => {

						let blob = new Blob([response.data], { type: "application/pdf" });
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = "customerReport" + this.start_date + "_" + this.end_date + ".pdf";
						link.click();
						
					})
					.catch((err) => console.log(err));
			},

			
		},
	};
</script>
